export default {
  Mercedes: '#00D2BE',
  Ferrari: '#DC0000',
  'Red Bull Racing': '#1E41FF',
  Renault: '#FFF500',
  Haas: '#F0D787',
  'Racing Point': '#F596C8',
  'Toro Rosso': '#469BFF',
  McLaren: '#FF8700',
  'Alfa Romeo': '#9B0000',
  Williams: '#FFFFFF',
} as { [key: string]: string; };

